import type { FormDefinition } from '../../../types/apiModels'
import { apiClient } from '../client'
import endpoints from '../endpoints'
import { unwrapCollection } from '../normalize'

// The v1 list handler answers `/formDefinitions/:id` with a `DataResponse` wrapping a
// Sequelize `findAll` result, so even a single-id lookup returns a collection envelope
// (`{ payload: FormDefinition[] }`). We unwrap the collection and take the first element.
export const getFormDefinition = async ({
  id,
  signal,
}: {
  id: string
  signal?: AbortSignal
}): Promise<FormDefinition> => {
  const response = await apiClient.get(`${endpoints.formDefinitions}/${id}`, { signal })
  const [formDefinition] = unwrapCollection<FormDefinition>(response)
  return formDefinition
}

export default getFormDefinition
